module.exports = __webpack_public_path__ + "img/poster1.2d56b98a.png";